import { render, staticRenderFns } from "./AuditsTableItem.vue?vue&type=template&id=44d85e2d&scoped=true"
import script from "./AuditsTableItem.vue?vue&type=script&lang=js"
export * from "./AuditsTableItem.vue?vue&type=script&lang=js"
import style0 from "./AuditsTableItem.vue?vue&type=style&index=0&id=44d85e2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d85e2d",
  null
  
)

export default component.exports